// extracted by mini-css-extract-plugin
export default {"StrollerDetailRating":"yc_a bii_a bii_x","StrollerDetailRating__muted":"yc_b bii_fo"};